import { ContentItem } from "@api";
import React from "react";
import VadImage from "vadimages-nextjs-image-optimizer";
import ReusableBatteriesSwiper from "./Sliders/ReusableBatteriesSwiper";

interface IReusableBatteriesSectionProps {
  pageContent: Record<string, ContentItem>;
}

export interface ReusableBatteriesCardProps {
  cardIndex: number;
  pageContent: Record<string, ContentItem>;
}

export const ReusableBatteriesCard = React.memo<ReusableBatteriesCardProps>(({ cardIndex, pageContent }) => {
  const title = pageContent[`reusable-batteries.${cardIndex}.title`]?.data ?? '';
  const body = pageContent[`reusable-batteries.${cardIndex}.body`]?.data ?? '';

  return (
    <div className='rounded-default bg-muted-tan px-6 py-10 space-y-4 text-center h-full'>
      <VadImage
        src={`/images/singular/check-mark.png`}
        alt={`Check mark`}
        width={34}
        height={34}
        className='mx-auto'
      />
      <h5 className='font-semibold text-warm-gray-copy'>{title}</h5>
      <p className='text-gray-copy'>{body}</p>
    </div>
  );
});

ReusableBatteriesCard.displayName = 'ReusableBatteriesCard';

const CARD_INDICES = [1, 2, 3, 4] as const;

const ReusableBatteriesSection = ({ pageContent }: IReusableBatteriesSectionProps) => {
  return (
    <>
      <div className='hidden lg:block'>
        <div className='grid grid-cols-4 gap-6'>
          {CARD_INDICES.map((cardIndex) => (
            <ReusableBatteriesCard 
              pageContent={pageContent} 
              cardIndex={cardIndex} 
              key={`reusable-batteries-card-${cardIndex}`} 
            />
          ))}
        </div>
      </div>
      <div className='block lg:hidden'>
        <ReusableBatteriesSwiper pageContent={pageContent} />
      </div>
    </>
  );
};

export default ReusableBatteriesSection;